<template>
  <div>
    <div class="subtitle-2 font-weight-medium text-uppercase mb-3">
      {{ labels.theme }}
    </div>
    <v-radio-group v-model="themeInput" class="mt-0">
      <v-radio :label="labels.light" value="Light"></v-radio>
      <v-radio :label="labels.dark" value="Dark"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import locale from '../locales/en.json';

export default {
  name: 'Theme',
  computed: {
    ...mapState('emsDashboard', ['theme']),
    labels() {
      return locale.dashboards;
    },
    themeInput: {
      get() {
        return this.theme && this.theme.isDark ? 'Dark' : 'Light';
      },
      set(val) {
        const isDark = val === 'Dark';
        this.$vuetify.theme.dark = isDark;
        const updatedTheme = { ...this.theme, isDark };
        this.setTheme(updatedTheme);
      },
    },
  },
  methods: {
    ...mapMutations('emsDashboard', ['setTheme']),
  },
};
</script>
